import { sendAnalyticsEvent } from '@faststore/sdk'
import React from 'react'
import { Helmet } from 'react-helmet-async'

import { Layout } from './src/Layout'
import { LocalStorageProvider } from './src/local_modules/contexts/LocalStorageContext'
import { AnalyticsHandler } from './src/local_modules/sdk/analytics'
import { ErrorBoundary } from './src/local_modules/sdk/error/ErrorBoundary'
import { TestProvider } from './src/local_modules/sdk/tests'
import { UIProvider } from './src/local_modules/sdk/ui/Provider'
import { handleUtmParams } from './src/local_modules/utils/utmTools'
import { metaTags } from './store.config'

import type { GatsbyBrowser } from 'gatsby'

import './src/styles/fonts.css'
import './src/styles/global.scss'
import './src/styles/layout.scss'
import './src/styles/theme.scss'

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
  element,
}) => (
  <ErrorBoundary>
    <AnalyticsHandler />
    <TestProvider>
      <UIProvider>
        <LocalStorageProvider>{element}</LocalStorageProvider>
      </UIProvider>
    </TestProvider>
  </ErrorBoundary>
)

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
}) => {
  return (
    <>
      <Helmet>
        <meta
          name="google-site-verification"
          content={metaTags['google-site-verification']}
        />

        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="anonymous"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <Layout>{element}</Layout>
    </>
  )
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (location && prevLocation) {
    sendAnalyticsEvent<any>({
      name: 'pageView',
      params: {
        location: location.href,
        page: location.pathname,
        referrer: prevLocation.href,
        title: document.title,
        originalLocation: location.href,
        originalReferrer: prevLocation.href,
      },
    })
  }

  handleUtmParams()
}

export const onInitialClientRender = () => {
  sendAnalyticsEvent<any>({
    name: 'pageView',
    params: {
      location: window.location.href,
      page: window.location.pathname,
      referrer: '',
      title: document.title,
      originalLocation: window.location.href,
      originalReferrer: '',
    },
  })
}
